import { Component, OnInit, Input } from '@angular/core';
import { DashboardService } from '../../../shared/providers/dashboard.service'
export enum BOVTAB {
    InformationUpload = 1,
    PriceAnalysis = 2,
    Review = 3
}

@Component({
    selector: 'app-bov',
    templateUrl: './bov.component.html',
    styleUrls: ['./bov.component.css']
})
export class BOVComponent implements OnInit {

    @Input() propertyId: number;
    bovTabs = BOVTAB;

    constructor(private _dashboardService: DashboardService) { }
    tabId = 0;
    ngOnInit() {
        this._dashboardService.GetBOEPropertyDocumentForReview(this.propertyId).subscribe(res => {
            if (res["Url"]) {
                this.tabId = BOVTAB.Review;
            }
            else {
                this.tabId = BOVTAB.InformationUpload;
            }
        })
    }

    onTabClick(id) {
      if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
        localStorage.removeItem('currentFileRefreshTab');
      }
        this.tabId = id;
    }

}
